import { NgModule } from '@angular/core';

import { DomService } from '../dom/dom.service';
import { OverlayContainer } from '../overlay/overlay-container';

@NgModule({
    providers: [
        DomService,
        OverlayContainer,
    ],
})

export class SharedModule {}
